export const currencyFormatter = (locale = 'en-US', style = 'currency', currency = 'USD') => {
    return new Intl.NumberFormat(
        locale,
        { style, currency }
    )
}